"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRouter = require("react-router");

var _jquery = _interopRequireDefault(require("jquery"));

var _eonasdanBootstrapDatetimepicker = _interopRequireDefault(require("eonasdan-bootstrap-datetimepicker"));

var _bootstrapDatetimepicker = _interopRequireDefault(require("../../../styles/bootstrap/bootstrap-datetimepicker.css"));

var _AppSelect = _interopRequireDefault(require("../AppSelect"));

var _lodash = _interopRequireDefault(require("lodash"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var AppTableFilter = /*#__PURE__*/function (_React$Component) {
  _inherits(AppTableFilter, _React$Component);

  function AppTableFilter(props) {
    var _this;

    _classCallCheck(this, AppTableFilter);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AppTableFilter).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "_debounceFilter", _lodash["default"].debounce(function () {
      return _this._triggerFilter();
    }, 200));

    _this.state = {
      filter: _this._getInitialFilter(props)
    };
    props.onInit(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(AppTableFilter, [{
    key: "getFilter",
    value: function getFilter() {
      return this.state.filter;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      (0, _jquery["default"])('.filter-datetime').each(function (index, element) {
        (0, _jquery["default"])(element).datetimepicker({
          useCurrent: false,
          format: 'DD/MM/YYYY HH:mm:ss'
        }).on('dp.change', function (e) {
          var filter = _this2.state.filter[(0, _jquery["default"])(e.target).closest('.single-filter-field').data('index')];

          if (!filter || filter.length == 0) return;
          var value = e.date.format ? e.date.format('DD/MM/YYYY HH:mm:ss') : null;
          setTimeout(function () {
            (0, _jquery["default"])(element).data('DateTimePicker').hide();

            _this2._changedFilter(filter, value, true);
          }, 50);
        });
      });
    }
    /**
     *
     * @param {Object} props Passed props
     */

  }, {
    key: "_getInitialFilter",
    value: function _getInitialFilter(props) {
      var filter = null;

      if (props.location.query.filter) {
        filter = this._joinFilters(props.filter, props.location.query.filter);
      } else {
        filter = props.filter;
      }

      return this._prepareFilter(filter);
    }
  }, {
    key: "_joinFilters",
    value: function _joinFilters(filter, otherFilters) {
      var mainFilter = _toConsumableArray(filter);

      otherFilters.forEach(function (otherFilter) {
        var existingFilter = mainFilter.find(function (x) {
          return x.name == otherFilter.name;
        });

        if (existingFilter) {
          var indexOf = mainFilter.indexOf(existingFilter);
          mainFilter[indexOf] = otherFilter; // mainFilter[indexOf] = {...existingFilter, ...otherFilter};
        } else {
          mainFilter.push(otherFilter);
        }
      });
      return mainFilter;
    }
  }, {
    key: "_prepareFilter",
    value: function _prepareFilter(filters) {
      if (!filters) return [];
      filters.forEach(function (filter, index) {
        if (filters[index].value === null || typeof filters[index].value == 'undefined') {
          filters[index].value = '';
        }
      });
      return filters;
    }
  }, {
    key: "_getElements",
    value: function _getElements(props) {
      var _this3 = this;

      var elements = [];

      if (!props.filter || props.filter.length == 0) {
        return elements;
      }

      props.filter.forEach(function (singleFilter, index) {
        var innerElement = null;

        switch (singleFilter.type) {
          case 'term':
            innerElement = _this3._getTermField(singleFilter, index);
            break;

          case 'datetime':
            innerElement = _this3._getDatetimeField(singleFilter, index);
            break;

          case 'select':
            innerElement = _this3._getSelectField(singleFilter, index);
            break;
        }

        if (innerElement) {
          elements.push(_react["default"].createElement("div", {
            style: {
              display: 'inline-block'
            },
            className: "single-filter-field",
            "data-index": index,
            key: 'filter' + index
          }, innerElement));
        }
      });
      return elements;
    }
  }, {
    key: "_getTermField",
    value: function _getTermField(singlefilter, index) {
      var _this4 = this;

      var label = singlefilter.label ? singlefilter.label : null;
      return _react["default"].createElement("div", {
        className: "filter-field",
        "data-index": index
      }, _react["default"].createElement("label", null, label), _react["default"].createElement("input", {
        type: "search",
        placeholder: "Search",
        value: this.state.filter[index] ? this.state.filter[index].value : null,
        onChange: function onChange(e) {
          _this4._changedFilter(singlefilter, e.target.value);

          _this4._debounceFilter();
        }
      }));
    }
  }, {
    key: "_getDatetimeField",
    value: function _getDatetimeField(singleFilter, index) {
      var _this5 = this;

      var label = singleFilter.label ? singleFilter.label : singleFilter.name;
      return _react["default"].createElement("div", {
        className: "filter-field",
        "data-index": index
      }, _react["default"].createElement("label", null, label), _react["default"].createElement("input", {
        className: "filter-datetime",
        type: "text",
        placeholder: "",
        value: this.state.filter[index] ? this.state.filter[index].value : null,
        onChange: function onChange(e) {
          _this5._changedFilter(singleFilter, e.target.value);
        }
      }));
    }
  }, {
    key: "_getSelectField",
    value: function _getSelectField(singleFilter, index) {
      var _this6 = this;

      var label = singleFilter.label ? singleFilter.label : singleFilter.name;
      return _react["default"].createElement("div", {
        className: "filter-field",
        "data-index": index
      }, _react["default"].createElement("label", null, label), _react["default"].createElement(_AppSelect["default"], _extends({
        textFieldProps: {
          disableUnderline: true,
          label: false,
          InputLabelProps: {
            shrink: true
          }
        }
      }, singleFilter.options, {
        onChange: function onChange(itemId) {
          _this6._changedFilter(singleFilter, itemId, true);
        },
        value: this.state.filter[index] ? this.state.filter[index].value : null
      })));
    }
  }, {
    key: "_changedFilter",
    value: function _changedFilter(filter, filterValue) {
      var _this7 = this;

      var reload = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      var filterCopy = _toConsumableArray(this.state.filter);

      var currentFilter = null;

      if (filter.name) {
        currentFilter = filterCopy.find(function (x) {
          return x.name == filter.name;
        });
      } else {
        currentFilter = filterCopy.find(function (x) {
          return x.field == filter.field;
        });
      }

      if (currentFilter) {
        currentFilter.value = filterValue;
        filterCopy[filterCopy.indexOf(currentFilter)] = currentFilter;
      } else {
        filterCopy.push(_objectSpread({}, filter, {
          value: filterValue
        }));
      }

      this.setState({
        filter: filterCopy
      }, function () {
        if (reload) {
          _this7._triggerFilter();
        }
      });
    }
  }, {
    key: "_triggerFilter",
    value: function _triggerFilter() {
      this.props.onFilter(this.state.filter);
    }
  }, {
    key: "_clearFilter",
    value: function _clearFilter() {
      var _this8 = this;

      var newFilter = _toConsumableArray(this.state.filter);

      newFilter.forEach(function (filter, index) {
        newFilter[index].value = '';
      });
      this.setState({
        filter: newFilter
      }, function () {
        _this8.props.onFilter(_this8.state.filter);
      });
    }
  }, {
    key: "_getClearFilterButton",
    value: function _getClearFilterButton() {
      var _this9 = this;

      var allEmpty = true;
      this.state.filter.forEach(function (filter) {
        if (filter.value) allEmpty = false;
      });
      if (allEmpty) return null;
      return _react["default"].createElement("button", {
        type: "button",
        className: "button-info",
        onClick: function onClick() {
          return _this9._clearFilter();
        }
      }, "Clear");
    }
  }, {
    key: "render",
    value: function render() {
      var _this10 = this;

      var elements = this._getElements(this.props);

      if (elements.length == 0) return null;

      var clearFilterButton = this._getClearFilterButton();

      return _react["default"].createElement("form", {
        onSubmit: function onSubmit() {
          return _this10._triggerFilter();
        },
        style: {
          padding: this.props.padded ? 10 : 0
        }
      }, elements, clearFilterButton, _react["default"].createElement("button", {
        type: "submit",
        className: "button-round",
        onClick: function onClick(e) {
          e.preventDefault();

          _this10._triggerFilter();

          return false;
        }
      }, "Search"));
    }
  }]);

  return AppTableFilter;
}(_react["default"].Component);

AppTableFilter.defaultProps = {
  onInit: function onInit() {},
  onFilter: function onFilter() {}
};

var _default = (0, _reactRouter.withRouter)(AppTableFilter);

exports["default"] = _default;